import React, { useState } from "react";
import moment from "moment";
import Summary from "../../../components/Summary";
import { connect } from "react-redux";
import ServicesGrowthWidget from "../../../components/ServicesGrowthWidget";
import NetlyPayOverview from "../../netlyPay/views/NetlyPayOverview";

const getGreeting = () => {
  const hour = moment().hour();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
};

/**
 * Netly Pay lives here as a tab rather than as a section of its own, which is
 * the design's navigation decision: the dashboard answers "how is the business
 * doing", and fees are part of that answer.
 *
 * Sales is the default. A shop that has not turned Netly Pay on sees the
 * Memberships tab carrying a NEW tag, and the tab itself renders the Enable
 * screen — NetlyPayOverview decides that from the link state, so this file
 * does not need to know whether the shop is set up.
 */
const TABS = [
  { key: "sales", label: "Sales" },
  { key: "memberships", label: "Memberships" },
];

export const DashboardView = (props: any) => {
  const { currentUser, selectedShop } = props;
  const [tab, setTab] = useState("sales");
  const today = moment().format("dddd, MMMM D YYYY");
  const firstName =
    currentUser?.firstName || currentUser?.name?.split(" ")[0] || "";

  return (
    <div className="flex flex-col w-full p-7 gap-6 nl-rise">
      {/* Greeting header */}
      <div className="flex items-end justify-between gap-5 flex-wrap">
        <div>
          <h1 className="text-[26px] font-semibold text-text1 tracking-[-0.035em] leading-tight">
            {getGreeting()}
            {firstName ? `, ${firstName}` : ""}
          </h1>
          <p className="text-[13.5px] text-text2 mt-1">
            {today}
            {selectedShop?.shopName ? ` · ${selectedShop.shopName}` : ""}
          </p>
        </div>
        <span className="flex items-center gap-2 text-xs font-semibold bg-pos-soft text-pos px-3.5 py-2 rounded-full">
          <span
            className="w-1.5 h-1.5 rounded-full bg-pos"
            style={{ animation: "pulseDot 1.8s ease-in-out infinite" }}
          />
          Live
        </span>
      </div>

      {/* Sales | Memberships */}
      <div className="flex gap-1 border-b border-borderc -mt-2">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setTab(t.key)}
            className={`px-3.5 py-2.5 text-[13.5px] border-b-2 transition-colors flex items-center gap-2 ${
              tab === t.key
                ? "border-brand text-text1 font-semibold"
                : "border-transparent text-text3 hover:text-text2"
            }`}
          >
            {t.label}
            {t.key === "memberships" && (
              <span className="text-[10px] font-semibold tracking-[.04em] bg-brand-soft text-brand px-1.5 py-0.5 rounded">
                NEW
              </span>
            )}
          </button>
        ))}
      </div>

      {tab === "sales" ? (
        <>
          <Summary />
          <ServicesGrowthWidget />
        </>
      ) : (
        <NetlyPayOverview />
      )}
    </div>
  );
};

export default connect(
  (state: any) => ({
    currentUser: state.setting.get("currentUser"),
    selectedShop: state.dashboard.get("selectedShop"),
  }),
  {}
)(DashboardView);
